import { createEffect, createStore } from 'effector';
import api from '../Auth/api';

export const $taskTypes = createStore([]);

export const getTaskTypesFx = createEffect(
    async () => {
        const response = await api.get(`/paid-service/task-type-list`);
        return response;
    }
);
$taskTypes.on(getTaskTypesFx, (_) => {
    return [];
});
$taskTypes.on(getTaskTypesFx.done, (_, { result }) => {
    return [...result.data.data];
});

$taskTypes.on(getTaskTypesFx.fail, () => {
    return [];
});
